// extracted by mini-css-extract-plugin
export default {"root":"PuoPDlXXjpGi6cdawlDw","placeHolderShimmer":"_N07bUtpGskO8TvIYScB"};